<div class="main container" *ngIf="validlink === true">
  <div class="full-center">
	  <div class="page-header">
	    <h1 class="text-center">Update Password</h1> 
	  </div>
	  <div class="row">
		  <div class="col-sm-12">
			  <form #kvForm="ngForm" name="kvForm" class="form" method="post">
			  	<label for="inputUsername" class="loginLabel">Username/Email</label>
				<input type="text" 
					[(ngModel)]='input.username' 
					id="inputUsername" name="inputUsername" 
					class="form-control" 
					placeholder="Enter the username or email" required autofocus />
				<span *ngIf="kvForm.form.controls['input.username']?.invalid && kvForm.form.controls['input.username']?.touched" class="required">
				  {{LOCALIZATION.required}}
				</span>					
					
				<label for="inputNewPass" class="loginLabel">New Password</label>
				<div *ngIf="showPolicy">
					<div [innerHTML]="popoverHTML"></div>
					<div class="arrow-down" ></div>
				</div>
				<input type="password" 
					[(ngModel)]='input.newpass' 
					(change)="validatePassword()"
					name="newpass" id="inputNewPass" 
					class="form-control" 
					placeholder="New Password" 
					(focus)="showPolicy=true" 
					(blur)="showPolicy=false" required />
				<span *ngIf="kvForm.form.controls['input.newpass']?.invalid && kvForm.form.controls['input.newpass']?.touched" class="required">
				  {{LOCALIZATION.required}}
				</span>					
					
				<label for="inputNewPassConfirm" class="loginLabel">Retype New Password</label>
				<input type="password" 
					[(ngModel)]='input.newpassConfirm' 
					id="inputNewPassConfirm" name="newpassConfirm" 
					class="form-control" placeholder="Retype New Password" required />
				<span *ngIf="kvForm.form.controls['input.newpassConfirm']?.invalid && kvForm.form.controls['input.newpassConfirm']?.touched" class="required">
				  {{LOCALIZATION.required}}
				</span>					

				<br>
				<button (click)="setPassword()" type="submit" class="btn btn-primary" [disabled]="!kvForm.valid">Set Password</button>
			  </form>
		  </div>
	  </div>
  </div>
</div>
<div class="main container" *ngIf="validlink === false">
	<div class="text-center full-center">
		<h1><span style="font-size:3em" class="glyphicon glyphicon-remove-sign text-red"></span></h1>
		<h3><span>{{errorMsg}}</span></h3>
	</div>
</div>
